import React from 'react';
import { Button, withStyles } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';

import axiosInstance, { EVENT_ID, EVENT_IMG, getUserID, WEB_API } from '../constatns';

const styles = (theme) => ({
  container: {
    border: '3px solid rgba(224, 224, 224, 1)',
    textAlign: 'center',
    width: '100%',
    height: '707px',
    position: 'relative',
  },
  certificateImg: {
    width: '100%',
    height: '100%',
  },
  nameWrap: {
    position: 'absolute',
    top: '35%',
    left: '50%',
    width: '100%',
    display: 'flex',
    transform: 'translateX(-50%)',
    justifyContent: 'center',
    '& > div': {
      fontSize: '2.2em',
    },
  },
});

class CertificateWin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: '',
      lastname: '',
    };
  }

  componentDidMount() {
    axiosInstance.get(`${WEB_API}/user/info?eventId=${EVENT_ID}&userId=${getUserID()}`).then((res) => {
      if (res.data && res.data.Item) {
        if (res.data.Item.firstName) this.setState({ firstname: res.data.Item.firstName });
        if (res.data.Item.lastName) this.setState({ lastname: res.data.Item.lastName });
      }
    });
  }

  onPrint() {
    // const innerBody = document.body.innerHTML;
    window.onbeforeprint = () => {
      document.getElementById('buttons').style.visibility = 'hidden';
      document.getElementById('buttons').style.height = 0;
      document.getElementById('container').style.borderWidth = 0;

      //   document.body.innerHTML = document.getElementById('print').innerHTML;
    };
    window.onafterprint = () => {
      document.getElementById('buttons').style.visibility = 'visible';
      document.getElementById('buttons').style.height = '46px';
      document.getElementById('container').style.borderWidth = '3px';
      //   document.body.innerHTML = innerBody;
    };
    window.print();
  }

  onClose() {
    window.opener = 'Self';
    window.open('', '_parent', '');
    window.close(); // 일반적인 현재 창 닫기
    window.open('about:blank', '_self').self.close(); // IE에서 묻지 않고 창 닫기
  }

  render() {
    const { classes } = this.props;
    return (
      <>
        <div id="buttons" style={{ padding: '5px 1em', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
          <Button color="primary" variant="contained" disableElevation startIcon={<PrintIcon />} onClick={() => this.onPrint()}>
            Print
          </Button>
          <div style={{ width: '1em' }} />
          <Button color="primary" variant="contained" disableElevation onClick={() => this.onClose()}>
            Close
          </Button>
        </div>
        <div id="print">
          <div className={classes.container} id="container">
            <img src={`${EVENT_IMG}/certificate.jpg`} className={classes.certificateImg} alt="" />
            <div className={classes.nameWrap}>
              <div id={'registration-receipt-name'} style={{ fontWeight: 'bold' }}>
                {this.state.lastname ? `${this.state.lastname} ${this.state.firstname}` : ''}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withStyles(styles)(CertificateWin);
